export const MENU_DRAWER_WIDTH = 240;
export const APP_BAR_HEIGHT = 64;
